import { render, staticRenderFns } from "./Informative.vue?vue&type=template&id=a18dfff0&scoped=true"
import script from "./Informative.vue?vue&type=script&lang=ts"
export * from "./Informative.vue?vue&type=script&lang=ts"
import style0 from "./Informative.vue?vue&type=style&index=0&id=a18dfff0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18dfff0",
  null
  
)

export default component.exports